import cookie from "js-cookie";

export const SetCookie = (key, value) => cookie.set(key, value, { expires: 7 });

export const GetCookie = (name) => cookie.get(name);

export const RemoveCookie = (name) => cookie.remove(name);
